module.exports = __webpack_public_path__ + "static/media/financial-worries@2x.9a6abe45.png";